import { render, staticRenderFns } from "./storeSubOrder.vue?vue&type=template&id=75fa6588"
import script from "./storeSubOrder.vue?vue&type=script&lang=js"
export * from "./storeSubOrder.vue?vue&type=script&lang=js"
import style0 from "./storeSubOrder.vue?vue&type=style&index=0&id=75fa6588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports